import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import newRoutesConfig from './config-new-ta';

const router = createBrowserRouter(newRoutesConfig);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
